/**
 * @author: Håvard Melvin Asperheim Hjelvik
 * @date: 05/10/2017
 */
import './base.scss'

import { SetupBugsnag } from '../../common';

import Dart from 'Dart';

class Base {
    static init = async () => {
        SetupBugsnag();

        try {

            const [SystemUsersPasswordChange, Login] = await Promise.all([
                import('../../../Modules/System/ViewTempl/js/SystemUserPasswordChange'),
                import('../../../Modules/MelvisAdmin/ViewTempl/js/Login'),
            ]);

            SystemUsersPasswordChange.default.init();
            Login.default.init();

            // Office TV — single module handles both the composite page and
            // the standalone Temporal page. Loaded only when either marker is
            // on the page, so the rest of /public never downloads it.
            if (document.querySelector('.office-tv[data-refresh-ms], .office-tv-temporal-page[data-refresh-ms]')) {
                const {default: startOfficeTV} = await import(
                    '../../../Modules/Hackday/ViewTempl/js/OfficeTV/office-tv.js'
                );
                startOfficeTV();
            }

        } catch(error) {
            console.error(error);
        }

    } // End init
} // End Base

Dart.ready(Base.init);